import { DriversData, DriverEntry } from '../interfaces'

export const formatDrivers = (drivers: DriversData) => {
  let result = drivers
    .filter(
      (c: DriverEntry) =>
        c.driver.approvedDocument === 2 &&
        c.driver.approvedLicence === 2 &&
        c.driver.approvedSelfie === 2
    )
    .map((c: DriverEntry) => {
      return {
        id: c.driver.personId,
        value: `${c.driver.lastName} ${c.driver.firstName}`,
      }
    })
    .sort((a: any, b: any) => {
      return a.value.localeCompare(b.value)
    })

  return result
}
